import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import WarrantyBadge from "../../Warranty/WarrantyBadge";
import styles from "./Header.module.css";

const Header = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = (e) => {
    e.stopPropagation();
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const closeOnOutside = () => {
      if (isMenuOpen) closeMenu();
    };

    document.addEventListener("click", closeOnOutside);
    window.addEventListener("scroll", closeOnOutside);

    return () => {
      document.removeEventListener("click", closeOnOutside);
      window.removeEventListener("scroll", closeOnOutside);
    };
  }, [isMenuOpen]);

  return (
    <>
      {/* ===== HEADER ===== */}
      <header className={styles.header} onClick={(e) => e.stopPropagation()}>
        {/* LOGO */}
        <div className={styles.logo}>
          <Link to="/" onClick={closeMenu}>
            <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="logo" />
          </Link>
          <h4 className={styles.logoText}>House Technology Trading</h4>
        </div>
        {/* WARRANTY */}
        <div className={styles.warranty}>
          <WarrantyBadge />
        </div>

        {/* DESKTOP MENU */}
        <nav className={styles.desktopNav}>
          <Link to="/">{t("header.home")}</Link>
          <Link to="/products">{t("header.products")}</Link>
          <Link to="/SmartDeals">{t("header.offer")}</Link>
          <Link to="/Contact">{t("header.contact")}</Link>
          <Link to="/about">{t("header.about")}</Link>
          <Link to="/faq">{t("faq.faq")}</Link>
        </nav>

        {/* HAMBURGER */}
        <div
          className={`${styles.hamburger} ${isMenuOpen ? styles.open : ""}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </header>

      {/* ===== MOBILE MENU ===== */}
      <div className={`${styles.mobileMenu} ${isMenuOpen ? styles.open : ""}`}>
        <div className={styles.background}></div>
        <div className={styles.shade}></div>

        <nav onClick={(e) => e.stopPropagation()}>
          <Link to="/" style={{ animationDelay: "0.2s" }} onClick={closeMenu}>
            {t("header.home")}
          </Link>
          <Link
            to="/products"
            style={{ animationDelay: "0.3s" }}
            onClick={closeMenu}
          >
            {t("header.products")}
          </Link>
          <Link
            to="/SmartDeals"
            style={{ animationDelay: "0.4s" }}
            onClick={closeMenu}
          >
            {t("header.offer")}
          </Link>
          <Link
            to="/Contact"
            style={{ animationDelay: "0.5s" }}
            onClick={closeMenu}
          >
            {t("header.contact")}
          </Link>
          <Link
            to="/about"
            style={{ animationDelay: "0.6s" }}
            onClick={closeMenu}
          >
            {t("header.about")}
          </Link>
          <Link
            to="/faq"
            style={{ animationDelay: "0.7s" }}
            onClick={closeMenu}
          >
            {t("faq.faq")}
          </Link>
        </nav>
      </div>
    </>
  );
};

export default Header;
